import { Component } from 'react';
import { IConvertedImages } from '../store/interface/IConvertedImages';

interface IProps {
  resizedThumbUrl?: IConvertedImages;
  imageSrc?: string;
  actionOnError: () => void;
}

let isSupportWebp: boolean | undefined;
/**
 * 画像の読み込みに失敗したかどうか判定するモジュール
 * propsで画像のURLと画像の読み込みに失敗した時に実行する関数を渡す
 * 注意 : リサイズ画像がある場合でも呼び出し元のコンポーネントでリサイズ画像とpictureタグを使用してない場合は
 * 　　　　 掲出される画像の条件が変わってしまう可能性がある為こちらのコンポーネントにもリサイズ画像を渡さないようにする。
 *
 * @param resizedThumbUrl
 * @param imageSrc
 * @param actionOnError エラー時に実行する関数を渡す
 */
export default class ThumbnailLoadCheckModule extends Component<IProps> {
  public componentDidMount() {
    this.checkImageSize();
  }

  public render() {
    return null;
  }

  /**
   * pictrans画像の場合404でも1x1画像が入ってくるので判定する
   */
  private checkImageSize() {
    const imageUrl = this.selectUseImageSrc();
    if (imageUrl === undefined) {
      return;
    }
    const img = document.createElement('img');
    img.onload = () => {
      // 一部の画像リクエストは404のときに1x1の画像を返すことがあるので、縦横ともに2px以上ない場合はエラーにする
      const width = img.width;
      const height = img.height;
      if (width < 2 || height < 2) {
        this.props.actionOnError();
      }
    };
    img.onerror = () => {
      this.props.actionOnError();
    };
    // ブラウザに合わせたフォーマットの画像URLを挿入
    img.src = imageUrl;
  }

  /**
   * 掲出する画像URLを取得する。
   */
  private selectUseImageSrc() {
    // pictureタグ非対応の場合
    if (!window.HTMLPictureElement) {
      return this.props.imageSrc;
    }

    // リサイズ画像がある場合
    if (this.props.resizedThumbUrl) {
      if (this.supportFormatWebp()) {
        // webp対応ブラウザの場合はwebp画像を出す。
        return this.props.resizedThumbUrl.webp;
      } else {
        return this.props.resizedThumbUrl.jpeg;
      }
    } else {
      return this.props.imageSrc;
    }
  }

  /**
   * webpサポートブラウザか検証する。
   * https://stackoverflow.com/questions/5573096/detecting-webp-support/27232658#27232658
   *
   * @returns boolean
   */
  private supportFormatWebp(): boolean {
    // 複数回webpサポート判定されているかの処理を行う必要がないので、結果を変数に保持する
    if (isSupportWebp !== undefined) {
      return isSupportWebp;
    }
    const elem = document.createElement('canvas');

    if (!!elem.getContext('2d')) {
      // was able or not to get WebP representation
      isSupportWebp = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    } else {
      // very old browser like IE 8, canvas not supported
      isSupportWebp = false;
    }
    return isSupportWebp;
  }
}
